import React from "react";

export interface AavoWizardStepProps {
	/** Label shown in the Stepper header. */
	label: string;
	/** Step content — only rendered when this step is active. */
	children: React.ReactNode;
}

/**
 * Marker component — not rendered directly.
 * AavoWizard extracts its props (label, children) and manages rendering.
 */
export const AavoWizardStep = (_props: AavoWizardStepProps): React.ReactNode => {
	return null;
};
